import { Button } from "antd";
import { AddTrackingToolToForm } from "components/Forms/AddTrackingToolToForm/AddTrackingToolToForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddTrackingToolToDrawerProps {
    onSubmit: () => void;
}

export const AddTrackingToolToDrawer: FC<AddTrackingToolToDrawerProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.add-tracking-tool-to");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.AddTrackingToolTo;
    const formId = FormId.AddTrackingToolToForm;
    const drawerUtils = useDrawer();

    const handleSubmit = async () => {
        drawerUtils.hide(id);
        onSubmit();
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={formId}>
                    {tC("save")}
                </Button>
            }
        >
            <AddTrackingToolToForm onSubmit={handleSubmit} formId={formId} />
        </Drawer>
    );
};
